import { transformCropIntoCoordinates } from './transforms';

/**
 * Renders an image onto a canvas element
 *
 * @param {HTMLImageElement}  image       Image to render
 * @param {HTMLCanvasElement} canvas      Canvas to render the image on
 * @param {number}            aspectRatio Aspect ratio of the image
 * @param {Crop}              crop        Crop object
 * @param {boolean}           isCircular  Is the image circular
 *
 * @return {void}
 */
const renderImageToCanvas = (image, canvas, aspectRatio, crop, isCircular) => {
  /* eslint-disable no-param-reassign */
  // Set the canvas width based on the crop, or image width
  canvas.width = image?.naturalWidth;
  // Set the canvas height based on the aspect ratio, crop height, or image height
  canvas.height = aspectRatio ? canvas.width / aspectRatio : image?.naturalHeight;
  /* eslint-enable no-param-reassign */

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return;
  }

  if (isCircular) {
    ctx.save();
    ctx.beginPath();
    ctx.ellipse(
      canvas.width / 2,
      canvas.height / 2,
      canvas.width / 2,
      canvas.height / 2,
      0,
      0,
      2 * Math.PI,
    );
    ctx.clip();
  }

  const coords = transformCropIntoCoordinates(crop, image.naturalWidth, image.naturalHeight);

  ctx.drawImage(
    image,
    coords.left,
    coords.top,
    coords.width,
    coords.height,
    0,
    0,
    canvas.width,
    canvas.height,
  );
};

export default renderImageToCanvas;
